var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-button',{staticClass:"global-ai-help-button",attrs:{"type":"text"},on:{"click":_setup.openAiComp}},[_vm._v(_vm._s(_vm.$t('bot-store.AI-Help-Generate')))])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }